function getUvKeyFromCookie () {
  const UV_COOKIE_KEY = `kj_uv`
  let uvKey = getCookie(UV_COOKIE_KEY)
  if (!uvKey) {
    uvKey = getUUID()
    let expiredAt = new Date(Date.now() + 30 * 365 * 24 * 3600 * 1000)
    setCookie(UV_COOKIE_KEY, uvKey, expiredAt, '/')
  }
  return uvKey
}

function setCookie (k, v, expires, path) {
  document.cookie = `${k}=${v};expires=${expires};path=${path}`
}

function getCookie (name) {
  // 获取单个cookies
  const cookie = document.cookie.split(';')
  for (var i = 0; i < cookie.length; i++) {
    var arr = cookie[i].split('=')
    if (name === arr[0].replace(/\s/g,'')) {
      if (arr.length > 1) {
        return arr[1]
      } else {
        return ''
      }
    }
  }
  return ''
}

function getUUID () {
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
}

function s4 () {
  return Math.floor((1 + Math.random()) * 0x10000)
  .toString(16)
  .substring(1)
}

export {getUvKeyFromCookie}



// WEBPACK FOOTER //
// ./src/common/util/getUvKeyFromCookie.js